module.exports = __webpack_public_path__ + "static/media/mouse_up.62bc5a54.mp3";